import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/contexts/I18nContext";

// Batch 27 · D (M37) — one note for "clearly trivial is 0 / not set" on every screen that uses it. No default % is ever
// assumed: the auditor sets it in 105(a). `onForm` = the note on the 105(a) form itself (no link to the page it is on).
export const ctIsSet = (v) => Number(v || 0) > 0;

export default function CtNotSetNote({ value, onForm = false, testid = "ct-not-set", className = "" }) {
  const { t } = useI18n();
  if (ctIsSet(value)) return null;
  return (
    <div role="status" data-testid={testid}
         className={`rounded border border-amber-300 bg-amber-50 px-2 py-1 text-xs text-amber-900 dark:border-amber-800 dark:bg-amber-950/30 dark:text-amber-200 ${className}`}>
      {onForm ? t("materiality.ctNotSet") : (
        <>
          {t("materiality.ctNotSetIn105a")}{" "}
          <Link to="/planning?openForm=materiality" className="font-medium underline" data-testid={`${testid}-link`}>
            {t("materiality.open105a")}
          </Link>
        </>
      )}
    </div>
  );
}
